const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/strategy/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
import { objectiveIdSearchParam } from '@/features/objectives/searchSchema';
const loopStrategySearchSchema = itemPanelSearchSchema.extend({
  jumpToObjectiveId: objectiveIdSearchParam
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/strategy/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('view_loop'),
  validateSearch: zodValidator(loopStrategySearchSchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.strategy)
    }
  }
});